import * as React from 'react'
import { Box, Fab, CircularProgress, Tooltip } from '@mui/material'
import { Edit, Delete, ToggleOn, ToggleOff } from '@mui/icons-material'
import { green, orange, blue, red } from '@mui/material/colors'
import { enableCountry, disableCountry } from '../../../services/countryService'

const CountryActions = ({ params, onEdit, onDelete, onRefresh }) => {
  const [loading, setLoading] = React.useState(false)

  const handleToggleStatus = async () => {
    setLoading(true)
    const { id, habilitado } = params.row
    const result = habilitado ? await disableCountry(id) : await enableCountry(id)
    if (result?.success && onRefresh) {
      onRefresh()
    }
    setLoading(false)
  }

  return (
    <Box sx={{ m: 1, position: 'relative', display: 'flex', gap: 0.5 }}>
      <Tooltip title="Editar">
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: blue[500],
              '&:hover': { bgcolor: blue[700] },
            }}
            disabled={loading}
            onClick={() => onEdit(params.row)}>
            <Edit sx={{ fontSize: 18, color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title={params.row.habilitado ? 'Deshabilitar' : 'Habilitar'}>
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: params.row.habilitado ? orange[500] : green[500],
              '&:hover': {
                bgcolor: params.row.habilitado ? orange[700] : green[700],
              },
            }}
            disabled={loading}
            onClick={handleToggleStatus}>
            {params.row.habilitado ? (
              <ToggleOff sx={{ fontSize: 18 }} />
            ) : (
              <ToggleOn sx={{ fontSize: 18 }} />
            )}
          </Fab>
        </span>
      </Tooltip>

      <Tooltip title="Eliminar">
        <span>
          <Fab
            sx={{
              width: 32,
              height: 32,
              minHeight: 32,
              bgcolor: red[500],
              '&:hover': { bgcolor: red[700] },
            }}
            disabled={loading}
            onClick={() => onDelete(params.row)}>
            <Delete sx={{ fontSize: 18, color: '#fff' }} />
          </Fab>
        </span>
      </Tooltip>

      {loading && (
        <CircularProgress
          size={40}
          sx={{ color: green[500], position: 'absolute', top: -4, left: -4, zIndex: 1 }}
        />
      )}
    </Box>
  )
}

export default CountryActions
